import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'joinDeep',
  standalone: true,
})
export class JoinDeepPipe implements PipeTransform {
  public transform<T>(
    value: readonly T[] | null | undefined,
    key: keyof T,
    separator = ', '
  ): string {
    if (!value || value.length === 0) {
      return '';
    }

    const parts: string[] = [];

    for (const item of value) {
      const raw = item[key];

      if (typeof raw === 'string' || typeof raw === 'number') {
        parts.push(String(raw));
      }
    }

    return parts.join(separator);
  }
}
